import React from "react";


export default function Stepper() {
    return (
            <div id="stepper1" className="bs-stepper">
                <div className="bs-stepper-header">
                    <div className="step" data-target="#test-l-1">
                    <span className="bs-stepper-circle">1</span>
                    <span className="bs-stepper-label">Time</span>
                </div>
                
                <div className="line"/>

                <div className="step" data-target="#test-l-2">
                    <span className="bs-stepper-circle">2</span>
                    <span className="bs-stepper-label">Register</span>
                </div>

                <div className="line"/>

                <div className="step" data-target="#test-l-3">
                    <span className="bs-stepper-circle">3</span>
                    <span className="bs-stepper-label">Review</span>
                </div>

                <div className="line"/>

                <div className="step" data-target="#test-l-4">
                    <span className="bs-stepper-circle">4</span>
                    <span className="bs-stepper-label">Confirm</span>
                </div>

                </div>
            </div>
    )
}

